import { Feature, t } from "util/stdtypes";
import { SpacesConfig, SpaceTemplate } from "feature/editorial-dash/spaces";

export const CommentSliderTemplate : SpaceTemplate = {
    key: 'comment-slider',
    label: t('Comment Slider'),
    description: t('Ask users to respond to your question along a spectrum (e.g. “Strongly no” to “Strongly yes”).'),
    imageUrl: 'images/comment-slider.svg',
    structureKey: 'question',
    featuresEnabled: ['commentslider'],
}

export const CommentSliderTemplateFeature : Feature<SpacesConfig, {}> = {
    key: 'comment-slider-template',
    name: 'Comment Slider Template',
    providesConfig: {
        templates: [CommentSliderTemplate]
    }
}
